<ms-event-switcher-toggle [event]="event" [mediaCount]="mediaTabsCount"></ms-event-switcher-toggle>
<ms-media-switcher *ngIf="event && !event.scoreboard?.isFinished" [event]="event" (mediaTabsCountChanged)="onTabsChanged($event)"></ms-media-switcher>
